<template>
    <div class="container sidebar">
        <div class="sidebar-content">
            <slot name="sidebar"></slot>
        </div>
        <div class="sidebar-after">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SidebarContentContainer"
    };
</script>

<style scoped lang="scss">
    .sidebar {
        display: flex;
        width: 100%;
        &-content {
            width: 280px;
            flex-shrink: 0;
            height: 100%;
        }
        &-after {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: calc(100% - 312px);
            max-width: calc(100% - 312px);
            margin-left: 32px;
            height: 100%;
        }
    }
</style>
